
import { defineComponent, computed, ref } from 'vue';
import * as FarmPoolPageComponents from '@/components/contextual/pages/farm';
import useNumbers from '@/composables/useNumbers';
import { EXTERNAL_LINKS } from '@/constants/links';
import useWeb3 from '@/services/web3/useWeb3';
import useApp from '@/composables/useApp';
import FlakeAction from './FlakeAction.vue';
import useFlakePoolQuery from '@/composables/queries/useFlakePoolQuery';
import useFlakeApprovalActions from '@/composables/useFlakeApprovalActions';
import useUserInfosQuery from '@/composables/queries/useUserInfosQuery';
import useUserLeaveRequestsQuery from '@/composables/queries/useUserLeaveRequestsQuery';

export default defineComponent({
  components: {
    ...FarmPoolPageComponents,
    FlakeAction
  },

  setup() {
    /**
     * COMPOSABLES
     */
    const { appLoading } = useApp();
    const { fNum2 } = useNumbers();
    const { isWalletReady, appNetworkConfig } = useWeb3();
    const baseFlakeInfosQuery = useFlakePoolQuery();
    const userInfosQuery = useUserInfosQuery();
    const { dynamicDataLoading } = useFlakeApprovalActions(
      [appNetworkConfig.addresses.flake || ''],
      ref(['1'])
    );
    const userLeaveRequestsQuery = useUserLeaveRequestsQuery();
    /**
     * QUERIES
     */

    /**
     * COMPUTED
     */
    const baseFlakeInfos = computed(() => baseFlakeInfosQuery.data.value);
    const userInfos = computed(() =>
      userInfosQuery.data.value ? userInfosQuery.data.value : []
    );
    const baseFlakeInfosLoading = computed(
      () =>
        baseFlakeInfosQuery.isLoading.value ||
        baseFlakeInfosQuery.isIdle.value ||
        baseFlakeInfosQuery.error.value ||
        dynamicDataLoading.value
    );

    const loadingPool = computed(
      () => baseFlakeInfosLoading.value || !baseFlakeInfos.value
    );

    return {
      // data
      EXTERNAL_LINKS,
      userLeaveRequestsQuery,
      // computed
      appLoading,
      loadingPool,
      isWalletReady,
      baseFlakeInfos,
      userInfos,
      // methods
      fNum2
    };
  }
});
